export const black = {
  50: 'rgba(0, 0, 0, 0.02)',
  100: 'rgba(0, 0, 0, 0.04)',
  200: 'rgba(0, 0, 0, 0.07)',
  300: 'rgba(0, 0, 0, 0.12)',
  400: 'rgba(0, 0, 0, 0.26)',
  500: 'rgba(0, 0, 0, 0.38)',
  600: 'rgba(0, 0, 0, 0.54)',
  700: 'rgba(0, 0, 0, 0.62)',
  800: 'rgba(0, 0, 0, 0.74)',
  900: 'rgba(0, 0, 0, 0.87)',
  1000: '#000000',
};

export const blue = {
  A50: 'rgba(6, 69, 173, 0.08)',
  50: '#EBF0F8',
  100: '#BFCFEA',
  200: '#90ACDB',
  300: '#628ACB',
  400: '#3266BC',
  500: '#0645AD',
  600: '#053EA6',
  700: '#04369C',
  800: '#032E93',
  900: '#021F83',
};

export const gray = {
  50: '#FBFBFB',
  100: '#F5F5F5',
  200: '#EEEEEE',
  300: '#E0E0E0',
  400: '#BDBDBD',
  500: '#9E9E9E',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
};

export const green = {
  A50: 'rgba(181, 228, 178, 0.25)',
  50: '#EDF8EC',
  100: '#D2EFD0',
  200: '#B5E4B2',
  300: '#9DD19A',
  400: '#83BE80',
  500: '#69AA66',
  600: '#57A153',
  700: '#43983F',
  800: '#2E8D29',
  900: '#287425',
};

export const purple = {
  A50: 'rgba(113, 62, 196, 0.06)',
  50: '#F6F3FB',
  100: '#DDD0F1',
  200: '#C1ABE5',
  300: '#A787DB',
  400: '#8C63D0',
  500: '#713EC4',
  600: '#6636B6',
  700: '#5B2DA7',
  800: '#4F2497',
  900: '#431A87',
};

export const red = {
  A50: 'rgba(174, 23, 23, 0.08)',
  50: '#F9ECEC',
  100: '#EBC4C4',
  200: '#DC9898',
  300: '#CD6D6D',
  400: '#BD4242',
  500: '#AE1717',
  600: '#A71414',
  700: '#9D1111',
  800: '#940D0D',
  900: '#840707',
};

export const white = '#ffffff';

export const yellow = {
  A50: 'rgba(255, 199, 0, 0.15)',
  50: '#FFF7D9',
  100: '#FAEAB2',
  200: '#F5DD88',
  300: '#EFCF5F',
  400: '#EAC136',
  500: '#E4B30D',
  600: '#E1AC08',
  700: '#DDA309',
  800: '#D99A07',
  900: '#D18B03',
};
